import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../core/Layout';
import { Encabezado } from '../core/Encabezado';

const CATEGORIAS = [
    {
        to: '/documentacion/legal/',
        icono: 'fas fa-gavel',
        titulo: 'Legal',
        texto: 'Contratos, avisos regulatorios, códigos de conducta y formatos simplificados por plan de servicio.',
    },
    {
        to: '/documentacion/usuario/',
        icono: 'fas fa-user',
        titulo: 'Usuario',
        texto: 'Folletos de bienvenida y guías de uso para clientes de Red Itmex.',
    },
];

class Documentacion extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Documentación">
                    <section className="paginaItmex docItmex">
                        <Encabezado
                            etiqueta="Documentación"
                            titulo="Documentación"
                            subtitulo="Consulta los documentos oficiales y regulatorios de Red Itmex."
                        />
                        <div className="docItmex-categorias">
                            {CATEGORIAS.map(c => (
                                <Link key={c.to} className="beneficiosPaso docItmex-categoria" to={c.to}>
                                    <span className="beneficiosPaso-icono"><i className={c.icono}></i></span>
                                    <h2 className="paginaItmex-tarjeta-titulo">{c.titulo}</h2>
                                    <p className="paginaItmex-tarjeta-texto">{c.texto}</p>
                                    <span className="planItmex-cta">
                                        Ver documentos
                                        <span className="planItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                    </span>
                                </Link>
                            ))}
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
}
export default Documentacion;
